interface CategoryBadgeProps {
  children: React.ReactNode;
  className?: string;
}

export function CategoryBadge({ children, className = "" }: CategoryBadgeProps) {
  return (
    <span
      className={`bg-surface-container-lowest/90 text-on-surface-variant rounded-full px-3 py-1 text-xs font-medium backdrop-blur-sm ${className}`}
    >
      {children}
    </span>
  );
}
